/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, {useEffect, useState, useCallback, useRef} from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBackspace, faBarcode, faBox, faCalendar, faCheck, faCheckCircle, faCloudUploadAlt, faCode, faCross, faDollarSign, faEdit, faHome, faHSquare, faPeopleArrows, faPhone, faPlug, faQrcode, faRocket, faSave, faSearch, faTasks, faUser, faUserShield, faWarehouse } from "@fortawesome/free-solid-svg-icons"
import { Badge, Button, ButtonGroup, Card, Col, Dropdown, Form, Image, InputGroup, Pagination, ProgressBar, Row, Table, Modal} from '@themesberg/react-bootstrap'
import Datetime from "react-datetime";
import { useDispatch, useSelector } from "react-redux"
import WaybillAction from "../../core/redux/action/WaybillAction"
import _ from "lodash"
import { WaybillStatus, WaybillStatusType } from "./WaybillPage"
//import USAFlag from '../../assets/img/flags/united-states-of-america.svg';
import USAFlag from '../../assets/img/flags/united-states-of-america.svg';
import CanadaFlag from '../../assets/img/flags/canada.svg';
import GermanyFlag from '../../assets/img/flags/germany.svg';
import FranceFlag from '../../assets/img/flags/france.svg';
import JapanFlag from '../../assets/img/flags/japan.svg';
import ItalyFlag from '../../assets/img/flags/italy.svg';
import ChinaFlag from '../../assets/img/flags/china.svg';
import PuPagination from "../../components/PuPagination"
import { Routes } from "../../routes"


import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Typography from '@material-ui/core/Typography';

import Progress from "../../components/Progress"
import { GetResultObject, PostRequest } from '../../core/API'
import { ApiSrc } from '../../resources/ApiSrc'
import { swal } from "sweetalert2/dist/sweetalert2";

var Barcode = require('react-barcode');

const moment = require('moment');

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflow: 'scroll'
  },
  button: {
    marginRight: theme.spacing(1),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  completed: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Pending', 'Warehouse', 'Ready For Transit', 'Transit', 'Arrived', 'Received'];
}

export default (props) => {
    const accountNoRef = useRef(null);

    const [receivedAt, setReceivedAt] = useState()   
    const [arrivedAt, setArrivedAt] = useState()
    const [width, setWidth] = useState()
    const [height, setHeight] = useState()
    const [length, setLength] = useState()
    const [weight, setWeight] = useState()
    const [volume, setVolume] = useState()
    const [freightFee, setFreightFee] = useState()
    const [status, setStatus] = useState()
    const [progressValue, setProgressValue] = useState();

    const [paid, setPaid] = useState()
    const [paidAmount, setPaidAmount] = useState()
    const [paidAt, setPaidAt] = useState()

    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState(new Set());    
    const steps = getSteps();
  
    const [showDefault, setShowDefault] = useState(false);
    const [accountNo, setAccountNo] = useState();
    const [receiver, setReceiver] = useState();
    const [receiverWarehouseId, setReceiverWarehouseId] = useState();
    
    const handleClose = () => setShowDefault(false);


    const handleStep = (step) => () => {
      console.log(step)
      if(step >= 5) return
      if(getSteps(step) == _.get(waybill, 'status')) {
        setStatus(undefined)
      }else{
        setStatus(steps[step])
      }
      setActiveStep(step);
    };

    function isStepComplete(step) {
      return completed.has(step);
    }
    

    const dispatch = useDispatch();
    const waybillRes = useSelector((state) => state.waybill);
    //const waybills = _.get(waybillRes, "waybillList.data");
    const waybill = _.get(waybillRes, 'waybill')

    useEffect(()=>{
        dispatch(WaybillAction.getWaybillDetail({
            "input": {
              "id": _.get(props, 'id')
            },
            "token": "string"
        }))
    },[])

    useEffect(()=>{
      PostRequest(ApiSrc.RECEIVER_DETAIL, {
        token: "", input: {accountNo: `JOONAAK-${accountNo}`}
      }).then(result => {
        GetResultObject(result, 'data', 200, (data) => {                                    
          setReceiver(data)
          setReceiverWarehouseId(_.get(data, 'warehouses[0].id'))
          console.log(">> receiver", receiver)
        })
      })
  },[accountNo])


    useEffect(()=>{      
      if(waybill){
        const index = steps.findIndex((value) => {return (value == _.get(waybill, 'status'))})
        console.log("> index", index)
        setActiveStep(index <= 0 ? 0 : index)
        
        setWidth(_.get(waybill, 'width'))
        setHeight(_.get(waybill, 'height'))
        setLength(_.get(waybill, 'length'))
        setWeight(_.get(waybill, 'weight'))
        setVolume(_.get(waybill, 'volume'))
        setFreightFee(_.get(waybill, 'freightFee'))
        setReceivedAt(_.get(waybill, 'receivedAt'))
        setArrivedAt(_.get(waybill, 'arrivedAt'))
        
        setPaid(_.get(waybill, 'paid'))
        setPaidAmount(_.get(waybill, 'paidAmount'))
        setPaidAt(_.get(waybill, 'paidAt'))
      }
    }, [waybill])

    const escFunction = useCallback((event) => {
        if(event.keyCode === 27) {
          //Do whatever when esc is pressed
          props.onClose && props.onClose()
        }
      }, [props]);
    
      useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
    
        return () => {
          document.removeEventListener("keydown", escFunction, false);
        };
      }, [escFunction]);



    const onUpdate = () => {
      const body = {
        id: _.get(props, 'id'),
        status,
        receivedAt,
        arrivedAt: status != "Arrived" ? undefined: arrivedAt,
        height,
        width,
        weight,
        length,
        volume, 
        freightFee,       
        paidAmount,
        paidAt,
        receiverWarehouseId,
      }

      if(paidAmount && paidAt){
        body.paid = true
      }
      
      if(body.status == "Arrived") { // pending
        body.status = "Transit"
      }

      console.log('>> body', body)
      setProgressValue(30)
        PostRequest(ApiSrc.UPDATE_WAYBILL, {input: {...body}, token: null}).then(result =>            
            GetResultObject(result, 'data', 200, (data) => {
                setProgressValue(100)
                dispatch(WaybillAction.updateWaybillSuccess(data));                  
                let timer = setInterval(function(){ 
                    props.onClose && props.onClose(timer)
                }, 1000);
            }, error => {
              swal('error')
            })
        )
      //dispatch(WaybillAction.updateWaybill({input: {...body}, token: null}));
    }

    if(waybill == undefined) {
      return <>
        <label>Loading</label>
      </>
    }

    

    return (
        <>      
        <React.Fragment>
          
          <Modal as={Modal.Dialog} centered show={showDefault} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title className="h6">Change Receiver</Modal.Title>
              <Button variant="close" aria-label="Close" onClick={handleClose} />
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mb-4">
                  <Form.Label>Account No</Form.Label>
                  <InputGroup>
                      <InputGroup.Text>
                          <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      <Form.Control   
                          ref={accountNoRef}                     
                          autoFocus={true}                                                                    
                          onChange={(e) => { setAccountNo(e.target.value) }}
                          value={accountNo}
                      />
                  </InputGroup>
              </Form.Group>  

              <fieldset>
                {
                  _.get(receiver, 'warehouses') && _.get(receiver, 'warehouses').map((item, index)=> {
                    return <Form.Check
                      defaultChecked={index == 0}
                      type="radio"
                      defaultValue={_.get(item, 'id')}
                      label={`${_.get(item, 'accountNo')} ${_.get(item, 'warehouse.country')}`}
                      name="ws"
                      id="radio1"
                      htmlFor="radio1"
                      onChange={(v)=>{setReceiverWarehouseId(_.get(item, 'id'))}}
                      />
                  })
                }                            
              </fieldset>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleClose}>
                Ok
            </Button>              
            </Modal.Footer>
          </Modal>
        </React.Fragment>
          {
            progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
          }
          <Card>
            <Card.Header>                        
            <div className={classes.root} style={{ overflowX: 'auto'}}>
              <Stepper alternativeLabel nonLinear activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const buttonProps = {};                                    
                  return (
                    <Step key={label} {...stepProps}>
                      <StepButton
                        onClick={handleStep(index)}
                        completed={isStepComplete(index)}
                        {...buttonProps}
                      >
                      {label}
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper>              
            </div>
              
            </Card.Header>

            <Card.Body>
              <Row>
                <Col>                  
                  <Form.Label>Receiver Detail</Form.Label>
                  <Row>
                      <Form.Group className="mb-4">
                        <Form.Label>Account No</Form.Label>
                        <InputGroup onClick={()=>{ 
                          if(_.get(waybill, 'paid')) return
                          setShowDefault(true)
                          accountNoRef && accountNoRef.current && accountNoRef.current.focus();
                        }} >
                            <InputGroup.Text >
                            <FontAwesomeIcon icon={faUser} />
                            </InputGroup.Text>
                            <Form.Control 
                              readOnly={true}                              
                              value={_.get(waybill, 'receiver.accountNo') }
                            />
                        </InputGroup>
                      </Form.Group>
                      <Form.Group className="mb-4">
                        <Form.Label>Name</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>
                            <FontAwesomeIcon icon={faUser} />
                            </InputGroup.Text>
                            <Form.Control 
                              readOnly={true}                              
                              value={_.get(waybill, 'receiver.firstName') ? _.get(waybill, 'receiver.firstName') : '' + ' ' + _.get(waybill, 'receiver.lastName') ? _.get(waybill, 'receiver.lastName') : ''}
                              required type="text" 
                              placeholder="Name" />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group className="mb-4">
                        <Form.Label>Phone</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>
                            <FontAwesomeIcon icon={faPhone} />
                            </InputGroup.Text>
                            <Form.Control 
                              readOnly={true}                              
                              value={_.get(waybill, 'receiver.phone' , '')}
                              required type="text" 
                              placeholder="Phone" />
                        </InputGroup>
                      </Form.Group>                      

                      <Form.Group className="mb-4">
                        <Form.Label>Address</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>
                            <FontAwesomeIcon icon={faPhone} />
                            </InputGroup.Text>
                            <Form.Control        
                              readOnly={true}                                                       
                              required type="text" 
                              placeholder="Address" />
                        </InputGroup>
                      </Form.Group>
                      
                      <Form.Group className="mb-4">
                        <Form.Label>Joonaak App { _.get(waybill, 'receiver.expressId') && <FontAwesomeIcon icon={faCheckCircle} color={'green'}/> } </Form.Label>
                      </Form.Group>

                      <InputGroup>
                        <Barcode value={_.get(waybill, 'warehouse.accountNo')} />
                      </InputGroup>                        

                      {
                            _.get(waybill, 'photo') && (
                                <Form.Group className="mb-4">
                                    <img src={_.get(waybill, 'photo')} />
                                </Form.Group> 
                            )
                      }
                      
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Form.Label>Good Detail</Form.Label>  
                    {
                      activeStep == 4 && (
                        <>
                          
                          <Form.Group className="mb-4">
                            <Form.Label>Arrived Date</Form.Label>
                            <Datetime
                              timeFormat={false}
                              onChange={setArrivedAt}
                              renderInput={(props, openCalendar) => (
                                <InputGroup>
                                  <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                                  <Form.Control
                                    required
                                    type="text"
                                    value={arrivedAt ? moment(arrivedAt).format("MM-DD-YYYY") : ""}
                                    placeholder="MM-DD-YYYY"
                                    onFocus={openCalendar}
                                    onChange={() => { }} />
                                </InputGroup>
                              )} />
                          </Form.Group>
                          
                        </>
                      )
                    }                   

                    {
                      activeStep == 5 && (
                        <>
                          
                          <Form.Group className="mb-4">
                            <Form.Label>Received Date</Form.Label>
                            <Datetime
                              timeFormat={false}
                              onChange={setReceivedAt}
                              renderInput={(props, openCalendar) => (
                                <InputGroup>
                                  <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                                  <Form.Control
                                    required
                                    type="text"
                                    value={receivedAt ? moment(receivedAt).format("MM-DD-YYYY") : ""}
                                    placeholder="MM-DD-YYYY"
                                    onFocus={openCalendar}
                                    onChange={() => { }} />
                                </InputGroup>
                              )} />
                          </Form.Group>
                          
                        </>
                      )
                    }

                    <Form.Group className="mb-4">    
                                      
                      <Form.Label>Shipment Type</Form.Label>                  
                      <InputGroup>
                          <InputGroup.Text>
                          <FontAwesomeIcon icon={faWarehouse} />
                          </InputGroup.Text>
                          <Form.Control 
                            readOnly={true}                              
                            required type="text" 
                            value={_.get(waybill, 'shipmentType')} />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-4">                                          
                      <Form.Label>From</Form.Label>                  
                      <InputGroup>
                          <InputGroup.Text>
                          <FontAwesomeIcon icon={faWarehouse} />
                          </InputGroup.Text>
                          <Form.Control 
                            readOnly={true}                              
                            required type="text" 
                            value={_.get(waybill, 'warehouse.warehouse.note')} />
                      </InputGroup>
                    </Form.Group>
                    
                    <Form.Group className="mb-4">
                    <Row>
                      <Col xs={12} sm={6} xl={4}>
                        <Form.Label>Width(cm)</Form.Label>  
                        <InputGroup>                                                
                          <InputGroup.Text>
                          <FontAwesomeIcon icon={faBox} />
                          </InputGroup.Text>
                          <Form.Control                                          
                            required type="number" 
                            onChange={(e)=>{setWidth(e.target.value)}}
                            value={width} />
                        </InputGroup>
                      </Col>
                      <Col xs={12} sm={6} xl={4}>
                        <Form.Label>Height(cm)</Form.Label>  
                        <InputGroup>                                                
                            <InputGroup.Text>
                            <FontAwesomeIcon icon={faBox} />
                            </InputGroup.Text>
                            <Form.Control                                          
                              required type="number" 
                              onChange={(e)=>{setHeight(e.target.value)}}
                              value={height} />
                        </InputGroup>  
                      </Col>
                      <Col xs={12} sm={6} xl={4}>
                        <Form.Label>Length(cm)</Form.Label>  
                        <InputGroup>                                                
                            <InputGroup.Text>
                            <FontAwesomeIcon icon={faBox} />
                            </InputGroup.Text>
                            <Form.Control                                          
                              required type="number" 
                              onChange={(e)=>{setLength(e.target.value)}}
                              value={length} />
                        </InputGroup>
                      </Col>                      
                    </Row>
                    </Form.Group>
                                      
                    <Form.Group className="mb-4">
                      <Form.Label>Weight(kg)</Form.Label>  
                    
                      <InputGroup>                                                
                          <InputGroup.Text>
                          <FontAwesomeIcon icon={faBox} />
                          </InputGroup.Text>
                          <Form.Control                                          
                            required type="number" 
                            onChange={(e)=>{setWeight(e.target.value)}}
                            value={weight} />
                      </InputGroup>
                    </Form.Group>   

                    <Form.Group className="mb-4">
                      <Form.Label>Volume(cmb)</Form.Label>  
                    
                      <InputGroup>                                                
                          <InputGroup.Text>
                          <FontAwesomeIcon icon={faBox} />
                          </InputGroup.Text>
                          <Form.Control                                          
                            required type="number" 
                            onChange={(e)=>{setVolume(e.target.value)}}
                            value={volume} />
                      </InputGroup>
                    </Form.Group> 
                  
                      
                    <Row>
                        <Col xs={12} sm={6} xl={4}>
                            <Form.Group className="mb-4">
                                <Form.Label>Freight Fee($)</Form.Label>  
                                
                                <InputGroup>                                                
                                    <InputGroup.Text>
                                    <FontAwesomeIcon icon={faDollarSign} />
                                    </InputGroup.Text>
                                    <Form.Control        
                                        onChange={(e)=>{setFreightFee(e.target.value)}}
                                        required type="number" 
                                        value={freightFee} />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} xl={4}>
                            <Form.Group className="mb-4">
                                <Form.Label>Paid Amount($)</Form.Label>                                  
                                <InputGroup>                                                
                                    <InputGroup.Text>
                                    <FontAwesomeIcon icon={faCheckCircle} color={ paid ? 'green' : ''}/>
                                    </InputGroup.Text>
                                    <Form.Control 
                                        readOnly={true}       
                                        onChange={(e)=>{setPaidAmount(e.target.value)}}                           
                                        required type="number" 
                                        value={paidAmount} />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} xl={4}>
                          <Form.Group className="mb-4">
                                <Form.Label>Settled Date</Form.Label>                                  
                                <InputGroup>                                                
                                    <InputGroup.Text>
                                    <FontAwesomeIcon icon={faCalendar} color={ paid ? 'green' : ''}/>
                                    </InputGroup.Text>
                                    <Form.Control 
                                        readOnly={true}                                               
                                        required type="text" 
                                        value={paidAt ? moment(paidAt).format("MM-DD-YYYY") : ''} />
                                </InputGroup>
                            </Form.Group>
                            {/* <Form.Group className="mb-4">
                                <Form.Label>Settled At</Form.Label>
                                <Datetime
                                timeFormat={false}
                                onChange={setPaidAt}
                                renderInput={(props, openCalendar) => (
                                    <InputGroup>
                                    <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                                    <Form.Control
                                        required
                                        type="text"
                                        value={paidAt ? moment(paidAt).format("MM-DD-YYYY") : ''}
                                        placeholder="MM-DD-YYYY"
                                        onFocus={openCalendar}/>
                                    </InputGroup>
                                )} />
                            </Form.Group> */}
                        </Col>
                    </Row>

                    <Form.Group className="mb-4">
                      <InputGroup> 
                        <Barcode value={_.get(waybill, 'reference')} />                                               
                      </InputGroup>
                    </Form.Group>   

                    
                                                                                             
                           
                  </Row>   
                  {
                      progressValue === undefined && (
                        <Form.Group className="mb-4 float-end">
                            <Button className={"bg-danger"} onClick={() => {props.onClose && props.onClose()}}><FontAwesomeIcon icon={faBackspace}/> Cancel</Button>&nbsp;&nbsp;&nbsp;
                            <Button onClick={onUpdate}><FontAwesomeIcon icon={faSave}/> Update</Button>                                                  
                        </Form.Group>                              
                      )
                    }                                      
                </Col>                
              </Row>
              
            </Card.Body>
            <Card.Body>
              <Row>
                  <Col xs={12} sm={1} xl={1}>
                  <Form.Label style={{fontSize: '10pt'}}></Form.Label> 
                  </Col>
                  <Col xs={12} sm={2} xl={2}>
                    <Form.Label style={{fontSize: '10pt'}}>Warehouse Date</Form.Label>
                  </Col>
                  <Col xs={12} sm={2} xl={2}>
                    <Form.Label style={{fontSize: '10pt'}}>Arrived Date</Form.Label>
                  </Col>
                </Row>
              {_.get(waybill, 'scanInAt') && (
                <Row>
                  <Col xs={12} sm={1} xl={1}>
                  <Form.Label style={{fontSize: '10pt'}}>Estimate:</Form.Label> 
                  </Col>
                  <Col xs={12} sm={2} xl={2}>
                    <Form.Label style={{fontSize: '10pt'}}>{ moment(_.get(waybill, 'scanInAt')).format("MM-DD-YYYY") }</Form.Label>
                  </Col>
                  <Col xs={12} sm={2} xl={2}>
                    <Form.Label style={{fontSize: '10pt'}}>{ moment(_.get(waybill, 'scanInAt')).add(10, 'day').format("MM-DD-YYYY") } (10)</Form.Label>
                  </Col>
                </Row>)                
              }
              {_.get(waybill, 'arrivedAt') && (
                <Row>
                  <Col xs={12} sm={1} xl={1}>
                  <Form.Label style={{fontSize: '10pt'}}>Actual:</Form.Label> 
                  </Col>
                  <Col xs={12} sm={2} xl={2}>
                    <Form.Label style={{fontSize: '10pt'}}>{ moment(_.get(waybill, 'scanInAt')).format("MM-DD-YYYY") }</Form.Label>
                  </Col>
                  <Col xs={12} sm={2} xl={2}>
                    <Form.Label style={{fontSize: '10pt'}}>{ moment(_.get(waybill, 'arrivedAt')).format("MM-DD-YYYY") } ({moment(_.get(waybill, 'arrivedAt')).startOf('day').diff(moment(_.get(waybill, 'scanInAt')).startOf('day'), 'days') })</Form.Label>
                  </Col>
                </Row>)             
              }
              {_.get(waybill, 'arrivedAt') && (
                <Row>
                  <Col xs={12} sm={1} xl={1}>
                  <Form.Label style={{fontSize: '10pt'}}>≃:</Form.Label> 
                  </Col>
                  <Col xs={12} sm={2} xl={2}>
                    <Form.Label style={{fontSize: '10pt'}}>10 ≃ {moment(_.get(waybill, 'arrivedAt')).startOf('day').diff(moment(_.get(waybill, 'scanInAt')).startOf('day'), 'days') } = {10 - moment(_.get(waybill, 'arrivedAt')).startOf('day').diff(moment(_.get(waybill, 'scanInAt')).startOf('day'), 'days') }</Form.Label>
                  </Col>                  
                </Row>)             
              }
            </Card.Body>
                                                   
            <Card.Footer>
            { waybill && (
                <div>
                <Row>
                  <Col>
                    {/* <Row>                      
                        <label>Account No</label>
                        {_.get(waybill, 'receiverAddress.accountNo')}
                    </Row> */}
                  </Col>
                  <Col></Col>
                </Row>
                <Row>                
                <label className="text-title">Logs</label>
                <ul style={{listStyleType: 'none'}}>
                  {_.orderBy(_.get(waybill, 'logs', []) , function(o) { return new moment(o.createdAt); }, ['desc']).map(item=>{
                    return <li>
                    <small>{ moment(_.get(item, 'createdAt')).format('DD-MM-YYYY HH:mm')}</small> : <WaybillStatus item={item} /> <small>{_.get(item, 'description')}
                    &nbsp;&nbsp;【{_.get(item, 'user.firstName')} {_.get(item, 'user.lastName')}】</small>
                    </li>
                  })}                                    
                </ul>                
                </Row>
                </div>  
              )}
            </Card.Footer>
          </Card>
        </>
    )
}
